var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-container"},[_c('div',{staticClass:"home-content",staticStyle:{"text-align":"center","height":"500px"}},[_c('img',{staticStyle:{"width":"288px","margin-top":"88px"},attrs:{"src":require("../assets/imgs/logo.png"),"alt":""}})])])
}]

export { render, staticRenderFns }